import React from 'react';
import { Box, SpaceBetween, StatusIndicator } from '@amzn/awsui-components-react';
import './DerivedAllocationSheet.scss';

/** Legend of the reference styles in Step 2 totals and Step 3 formulas: Step 1 data sources and Step 2 totals. */
export default function DasExpressionLegend() {
    return (
        <div data-class="dasExpressionLegend" className="dasExpressionLegend">
            <SpaceBetween direction="horizontal" size="xs">
                <StatusIndicator type="info"><Box variant="small" color="inherit">References:</Box></StatusIndicator>
                <span className="calcExpression-D">Step-1 data source</span>
                <span className="calcExpression-S">Step-2 total</span>
            </SpaceBetween>
        </div>
    );
}
